"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Easings = {
    LINEAR: function (t) { return t; },
    IN_QUAD: function (t) { return t * t; },
    OUT_QUAD: function (t) { return t * (2 - t); },
    IN_OUT_QUAD: function (t) { return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t; },
    IN_CUBIC: function (t) { return t * t * t; },
    OUT_CUBIC: function (t) { return (--t) * t * t + 1; },
    IN_OUT_CUBIC: function (t) { return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1; },
    IN_QUART: function (t) { return t * t * t * t; },
    OUT_QUART: function (t) { return 1 - (--t) * t * t * t; },
    IN_OUT_QUART: function (t) { return t < .5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t; },
    IN_QUINT: function (t) { return t * t * t * t * t; },
    OUT_QUINT: function (t) { return 1 + (--t) * t * t * t * t; },
    IN_OUT_QUINT: function (t) { return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t; },
};
exports.default = Easings;
